import { Avatar, Box, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { TaskEnums } from "../../../../common/constants";
import { Close as CloseIcon } from "@mui/icons-material"

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      display: "flex"
    },
    noDriverAvatar: {
      border: `2px dashed ${theme.palette.divider}`,
      background: "none"
    },
    driverRejectedAvatar: {
      border: `2px solid ${theme.palette.error.main}`,
      background: theme.palette.error.background
    },
    driverPendingAvatar: {
      border: `2px solid ${theme.palette.divider}`,
      background: "none",
      "& img": {
        width: "16px",
        height: "16px"
      }
    }
  })
);


export default function DriverColumn(props) {
  const { task } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { execution, driverData } = task;
  const { driver, driverAssignedState } = execution;
  const hasDriver = !!driver?.id;
  const loading = hasDriver && !driverData;

  return loading ? (
    <Skeleton width={100} variant="rounded" />
  ) : (
    <Box className={classes.root}>
      <Stack direction="row" className={classes.root} justifyContent="flex-start" alignItems="center" spacing={1.5}>
        {
          hasDriver ? (
            <>
              {
                driverAssignedState === TaskEnums.DriverAssignedState.Rejected ? (
                  <Avatar className={classes.driverRejectedAvatar}>
                    <CloseIcon color="error" />
                  </Avatar>
                ) : driverAssignedState === TaskEnums.DriverAssignedState.Pending ? (
                  <Avatar
                    className={classes.driverPendingAvatar}
                    src="/assets/icons/animations/hourglass-24.apng"
                  />
                ) : (
                  <Avatar
                    src={driverData?.picture}
                  />
                )
              }
              <Stack direction="column">
                <Typography variant="body2" fontWeight={500}>{driver?.name || ""}</Typography>
                <Typography variant="caption" color="textSecondary">{driverData?.vehicle?.name || t("dispatch:table:noCar")}</Typography>
              </Stack>
            </>
          ) : (
            <>
              <Avatar className={classes.noDriverAvatar}><span></span></Avatar>
              <Typography variant="body2" fontWeight={500} color="textDisabled">{t("dispatch:table:noDriverAssigned")}</Typography>
            </>
          )
        }
      </Stack>
    </Box >
  );
}